export const VISITED_ID_CACHE_KEY = 'disableNewBadges';
